module.exports = __webpack_public_path__ + "img/numCard-8_En.57fcd7fb.svg";